import { render, staticRenderFns } from "./new_cnab_remittance_config.vue?vue&type=template&id=32d73234&"
import script from "./new_cnab_remittance_config.vue?vue&type=script&lang=js&"
export * from "./new_cnab_remittance_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports